import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Tag_Source_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_TAG_SOURCE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Tag Source Id', columnResourceName: 'colWBTagSourceId', alignment: HorizAlignment.Center}, domainOptions: {}},
    TAG_SOURCE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Source Id', columnResourceName: 'colTagSourceId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    TAG_SOURCE_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Source Name', columnResourceName: 'colTagSourceName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SOURCE_TABLENAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Table Name', columnResourceName: 'colSourceTableName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    TAG_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Field Name', columnResourceName: 'colTagFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    EVENT_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Field Name', columnResourceName: 'colEventFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    CUSTOMER_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Field Name', columnResourceName: 'colCustomerFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    PRODUCT_FIELDTYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Field Type', columnResourceName: 'colProductFieldType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Field Name', columnResourceName: 'colProductFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    PERIOD_METHOD:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Period Method', columnResourceName: 'colPeriodMethod', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 20}},
    PERIOD_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Period Field Name', columnResourceName: 'colPeriodFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    EFFECTIVE_START_DT_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Effective Start Dt Field Name', columnResourceName: 'colEffectiveStartDtFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    EFFECTIVE_END_DT_FIELDNAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Effective End Dt Field Name', columnResourceName: 'colEffectiveEndDtFieldName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 128}},
    CREATED_DTTS:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created DtTs', columnResourceName: 'colCreatedDtTs', alignment: HorizAlignment.Left}, domainOptions: {}},
    MODIFIED_DTTS:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified DtTs', columnResourceName: 'colModifiedDtTs', alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_IND:       {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Deleted Ind', columnResourceName: 'colDeletedInd', alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_DT:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Dt', columnResourceName: 'colDeletedDt', alignment: HorizAlignment.Left}, domainOptions: {}},
}

var TagSourceSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_TAG_SOURCE_ID',
        id_ui: 'TAG_SOURCE_ID',
        name:  'TAG_SOURCE_NAME'},

    searchProviderFields: vUI_Tag_Source_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Tag_Source_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var TagSourceSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "TagSourceSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'TAG_SOURCE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'TAG_SOURCE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'TAG_SOURCE_NAME', 'TAG_SOURCE_ID', 'SOURCE_TABLENAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: TagSourceSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var TagSourceSearch: ISearch = {
    searchName: "Find Tag Source",
    renderOptions: { ui5ResourceId: "TagSourceSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [TagSourceSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("TagSourceBO", "TagSource", TagSourceSearch, "Tag Source Search")

export {TagSourceSearch}